export default __webpack_public_path__ + "static/media/hht2_ep14_timeline_q01_a.d5dcc294.png";